import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import WalletLogin from './WalletLogin';
import { onChange } from '../../common/actions';
import {
  getKey,
  isInsufficientBalance,
  calculateAmountPayable,
  money,
  defaultSelected,
  isAddNPay
} from '../../utils/common';
import { PAYMENT_FLOW, API, PAYMODE } from '../../../../common/src/constant';
import CONSTANT, { CACHE } from '../../utils/constants';
import { handlePostData } from '../../utils/formPost';
import WalletToggleWarning from '../walletToggleWarning';
import LOCALE from '../../locale/en';
import { EVENT, log } from '../../common/logger';
import PaymodeOffer from '../offers/paymodeOffer';

class Wallet extends Component {
  componentDidMount() {
    if (this.props.wallet && this.props.wallet.isEnabled && this.props.wallet.isUsed) {
      this.props.fetchPcf(this.props.wallet);
      this.props.applyPromoForPayMode(this.props.wallet);
      if (!this.props.insufficientBalance) {
        setTimeout(() => {
          this.props.onSelectChange(this.props.wallet);
        }, 0);
      } else {
        log({ eventType: EVENT.WALLET_BALANCE_INSUFFICIENT });
      }
    }
  }

  walletToggle = e => {
    if (this.props.selectedEmiPlan) {
      // e.stopPropagation();
      this.setState({ walletToggleWarning: true });
      return;
    }

    const paymentOptions = { ...this.props.cache.getData('paymentOptions') };
    /* if paymode has hybrid disabled  disable wallet check */
    if (
      this.props.selected &&
      this.props.selected.isHybridDisabled &&
      !this.props.selected.type === 'mgv'
    ) {
      const wallet = { ...paymentOptions.wallet, isUsed: false };
      paymentOptions.wallet = wallet;
      this.props.cache.setData(CACHE.PAYMENT_OPTIONS, paymentOptions);
      this.props.onWalletToggle(wallet);
      this.props.onPayDataChange(paymentOptions);
      return;
    }

    this.props.isPromoAvailable &&
      this.props.cache.setData(
        CONSTANT.TXN_AMOUNT,
        this.props.cache.getData(CONSTANT.UNMODIFIED_TXN_AMOUNT)
      );
    const wallet = { ...paymentOptions.wallet, isUsed: e.checked ? e.checked : e.target.checked };

    if (paymentOptions && getKey(paymentOptions, 'wallet')) {
      if (
        paymentOptions.paymentFlow !== PAYMENT_FLOW.ADDANDPAY &&
        !(money(paymentOptions.wallet.walletBalance) > 0)
      ) {
        e.preventDefault();
        return;
      }
      const insufficientBalance = isInsufficientBalance(paymentOptions, this.props.cache);
      let selected;
      if (!insufficientBalance) {
        if (e.checked || (e.target && e.target.checked)) {
          selected = wallet;
          // setting selected bank on option change to be included in defered flow
          this.props.cache.setData(CACHE.SELECTEDBANK, null);
          this.props.cache.setData(CACHE.CARD_DETAILS, null);
        }
      } else if (paymentOptions.paymentFlow === PAYMENT_FLOW.ADDANDPAY) {
        if (e.checked || (e.target && e.target.checked)) {
          paymentOptions.payData = paymentOptions.addMoneyPayOption;
        } else {
          paymentOptions.payData = paymentOptions.merchantPayOption;
        }
        selected = defaultSelected(paymentOptions, this.props.cache);
      } else if (paymentOptions.paymentFlow === PAYMENT_FLOW.HYBRID) {
        paymentOptions.payData = paymentOptions.merchantPayOption;
        if (e.checked || (e.target && e.target.checked)) {
          if (insufficientBalance) {
            selected = this.props.selected;
          } else {
            selected = null;
          }
        } else {
          selected = this.props.selected;
        }
      } else {
        paymentOptions.payData = paymentOptions.merchantPayOption;
        this.props.selected && !this.props.selected.type === 'mgv'
          ? (selected = this.props.selected)
          : (selected = this.props.wallet);
      }

      this.props.cache.setData(CONSTANT.CURRENT_PAYMODE, selected);
      paymentOptions.wallet = wallet;
      this.props.cache.setData(CACHE.PAYMENT_OPTIONS, paymentOptions);
      this.props.onSelectChange(selected);
      this.updatePaytext(paymentOptions, selected);
      const nextSelectable =
        selected && !Object.prototype.hasOwnProperty.call(selected, 'isWalletOnly')
          ? selected
          : wallet;
      this.props.updatePromoEnableStatus(selected, nextSelectable);
      this.props.fetchPcf(nextSelectable);
      this.props.onWalletToggle(wallet);
      this.props.onPayDataChange(paymentOptions);
    }
  };

  updatePaytext = (paymentOptions, selected) => {
    const txnAmount = this.props.cache.getData(CONSTANT.TXN_AMOUNT);
    const amountPayable = calculateAmountPayable(
      txnAmount,
      getKey(paymentOptions, 'wallet'),
      true,
      this.props.subscription
    );

    let payAmountText = LOCALE.payButton.text + amountPayable;
    if (isAddNPay(paymentOptions, this.props.cache) && (selected && selected.type !== 'mgv')) {
      payAmountText = LOCALE.payButton.addNPayText.replace('amount', amountPayable);
    }
    this.props.onPayChange(true);
    this.props.onBtnTextChange(payAmountText);
  };

  handleAfterPay = response => {
    const { callBackUrl, txnInfo } = getKey(response, 'body', undefined);
    response.body.content = txnInfo;
    response.body.callbackUrl = callBackUrl;
    handlePostData(response, this.props.cache);
  };

  submit = () => {
    const payload = this.props.cache.getData(CACHE.API).requestPayload(API.PT);
    const paymentOptions = this.props.cache.getData('paymentOptions');
    let reqData = {
      body: {
        paymentMode: CONSTANT.WALLET,
        authMode: CONSTANT['3D'],
        paymentFlow: paymentOptions.paymentFlow
      }
    };
    reqData = { ...reqData.body, ...payload.query };
    this.props.cache.getData(CACHE.STORE).setState({ overlayValue: CONSTANT.PROCESSING });
    this.props.cache
      .getData(CACHE.API)
      .pay(reqData)
      .then(response => {
        this.props.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
        if (response && getKey(response, 'body.resultInfo.resultStatus') === 'S') {
          this.handleAfterPay(response);
        }
      })
      .catch(() => {
        this.props.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
      });
  };

  closeWalletWarning = () => {
    // when the user selects okay on wallet warning message hide the popup
    this.setState({ walletToggleWarning: false });
  };

  shouldComponentUpdate(nextProps) {
    return Boolean(nextProps.wallet);
  }

  toggleWallet = () => {
    // when the user selects okay on wallet warning message change the wallet state
    const paymentOptions = { ...this.props.cache.getData('paymentOptions') };
    const wallet = { ...paymentOptions.wallet, isUsed: true };
    if (wallet.isUsed) {
      this.props.onSelectedPlan(null);
    }
    // const Selected = this.props.wallet;
    paymentOptions.wallet = wallet;
    this.props.cache.setData(CACHE.PAYMENT_OPTIONS, paymentOptions);
    this.props.onWalletToggle(wallet);
    const txnAmount = this.props.cache.getData(CONSTANT.TXN_AMOUNT);
    const amountPayable = calculateAmountPayable(
      txnAmount,
      paymentOptions.wallet,
      true,
      this.props.subscription
    );
    this.props.onBtnTextChange(LOCALE.payButton.text + amountPayable);
    this.props.onSelectChange(wallet);
    this.props.onPayDataChange(paymentOptions);
    this.setState({ walletToggleWarning: false });
  };

  render(
    { wallet, insufficientBalance, offers, isPromoAvailable, instanceKey },
    { walletToggleWarning }
  ) {
    const isWalletUsed = getKey(wallet, 'isUsed', false);
    const walletOffer = isPromoAvailable
      ? isWalletUsed
        ? getKey(offers, PAYMODE.WALLET)
        : getKey(wallet, 'paymentOfferDetails')
      : null;

    let isWalletDisabled = false;
    if (wallet.isWalletOnly || !wallet.isEnabled) {
      isWalletDisabled = true;
    }
    return (
      <div
        class={`ptm-pay-method ptm-w100-ib ${isWalletDisabled ? 'ptm-walletDisabled' : ''}`}
        id="checkout-wallet"
      >
        <div id="wallet_check" class={`ptm-radio-wrap`}>
          <label class="ptm-container">
            <input
              type="checkbox"
              name={`verify${instanceKey}`}
              className="ptm-margin0"
              id="wallet_checkbox"
              checked={wallet.isUsed}
              disabled={isWalletDisabled}
              onClick={e => {
                this.walletToggle(e);
              }}
            />
            <span className="ptm-check" />
            <WalletLogin {...{ wallet, insufficientBalance }} />
          </label>
        </div>
        {walletToggleWarning && (
          <div className={`ptm-overlay-black`}>
            <WalletToggleWarning
              {...{ wallet }}
              closeWalletWarning={this.closeWalletWarning}
              toggleWallet={this.toggleWallet}
            />
          </div>
        )}
        {walletOffer && <PaymodeOffer offer={walletOffer} applied={isWalletUsed} />}
      </div>
    );
  }
}
export default connect(
  'selected,wallet,selectedEmiPlan, cache, subscription',
  onChange
)(Wallet);



// WEBPACK FOOTER //
// ./components/wallet/index.js